const BASE_URL = process.env.REACT_APP_BACKEND_CONNECTION || "";

export function getImageUrl(imageName) {
  if (!imageName) return "";
  if (imageName.startsWith("http://") || imageName.startsWith("https://")) {
    return imageName;
  }

  const normalizedPath = imageName.startsWith("/images/")
    ? imageName
    : `/images/${imageName}`;

  return BASE_URL ? `${BASE_URL}${normalizedPath}` : normalizedPath;
}